import * as ConfigTypes from 'config/ConfigTypes';

export const isWorkOfLane = ({ mediaObjects, workId }) => {
    const { lanes, viewMode, currentLane } = mediaObjects;

    if (viewMode === ConfigTypes.HOME) {
        if (lanes && lanes[currentLane.id] && lanes[currentLane.id].indexOf(workId) != -1) {
            console.log("LOGS: isWorkOfLane = true");
            return true;
        }
        return false;
    }
    return true;
}